export default __webpack_public_path__ + "static/media/tg.37fa7be3.svg";